import React, { useEffect } from 'react';
import { Row, Col, Input, Button, Form, Drawer, InputNumber } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { putApi } from 'redux/sagas/putApiSaga';
import { API_STATUS } from 'constants/app-constants';
import { SERVER_IP } from 'assets/Config';
import { postApi } from 'redux/sagas/postApiDataSaga';
import { resetApiStatus } from 'redux/reducers/globals/globalActions';
import { useI18n } from 'hooks/useI18n';

const AddPeriod = ({ periodAddModal, width = '40%', editPeriod, setPeriodAddModal, refreshList, handleClose }) => {
	const [form] = Form.useForm();
	const globalRedux = useSelector((state) => state.globalRedux);
	const branchId = globalRedux?.selectedBranch?.id;
	const dispatch = useDispatch();
	const { t } = useI18n();

	useEffect(() => {
		// Only update form fields when the drawer is open to avoid races
		if (periodAddModal) {
			if (editPeriod) {
				form.setFieldsValue({
					name: editPeriod?.name || '',
					days: editPeriod?.days || '',
				});
			} else {
				// Ensure form is cleared when creating a new period
				form?.resetFields();
			}
		}
	}, [editPeriod, periodAddModal, form]);

	useEffect(() => {
		if (!periodAddModal) {
			form?.resetFields();
		}
	}, [periodAddModal, form]);

	const handleSubmit = (values) => {
		let data = {
			name: values?.name || '',
			days: values?.days || '',
			branchId,
		};

		if (!editPeriod) {
			dispatch(postApi(data, 'ADD_PERIOD'));
		} else {
			let url = `${SERVER_IP}api/period/${editPeriod.id}`;
			dispatch(putApi(data, 'EDIT_PERIOD', url));
		}
	};

	useEffect(() => {
		if (globalRedux.apiStatus.ADD_PERIOD === 'SUCCESS' || globalRedux.apiStatus.EDIT_PERIOD === 'SUCCESS') {
			dispatch(resetApiStatus(editPeriod ? 'EDIT_PERIOD' : 'ADD_PERIOD'));
			refreshList?.();
			handleClose?.();
			form?.resetFields();
		}
	}, [globalRedux.apiStatus, editPeriod, setPeriodAddModal, dispatch, refreshList, handleClose, form]);

	const layer1FormCol = {
		labelCol: {
			span: 12,
		},
		wrapperCol: {
			span: 12,
		},
	};

	const loading = globalRedux.apiStatus.ADD_PERIOD === API_STATUS.PENDING || globalRedux.apiStatus.EDIT_PERIOD === API_STATUS.PENDING;

	return (
		<Drawer
			placement="right"
			title={editPeriod ? `${t('common.edit')} ${t('periods.create_period')}` : t('periods.create_period')}
			width={width || '40%'}
			visible={periodAddModal}
			closable
			onClose={() => setPeriodAddModal(false)}
			destroyOnClose={true}>
			<Row>
				<Col span={24}>
					<Row style={{ marginTop: 20 }}>
						<Form
							name="add-period"
							className="required_in_right"
							style={{ width: '100%' }}
							colon={true}
							labelAlign="left"
							form={form}
							onFinish={handleSubmit}
							initialValues={{}}
							{...layer1FormCol}>
								<Form.Item
									label={t('periods.columns.period_name')}
									name="name"
									rules={[
										{
											required: true,
											message: t('forms.this_field_required'),
										},
									]}>
									<Input placeholder={t('periods.columns.period_name')} />
								</Form.Item>
							<Form.Item
								label={t('periods.columns.days')}
								name="days"
								rules={[
									{
										required: true,
										message: t('forms.this_field_required'),
									},
								]}>
								<InputNumber
									placeholder={t('periods.columns.days')}
									style={{
										width: '100%',
									}}
								/>
							</Form.Item>
							<Form.Item
								wrapperCol={{
									offset: 0,
									span: 24,
								}}>
								<Row className="space-between" style={{ paddingTop: 20, width: '100%', margin: 0 }}>
									<Button danger style={{ width: '49%' }} onClick={() => setPeriodAddModal(false)}>
										{t('common.cancel')}
									</Button>
									<Button loading={loading} style={{ width: '49%' }} type="primary" htmlType="submit">
										{editPeriod ? t('common.update') : t('common.save')}
									</Button>
								</Row>
							</Form.Item>
						</Form>
					</Row>
				</Col>
			</Row>
		</Drawer>
	);
};

export default AddPeriod;
